import * as React from 'react';
import type { SVGProps } from 'react';
const SvgKey7 = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M13.598 4C8.863 4 5 7.863 5 12.598v25.804C5 43.137 8.863 47 13.598 47h22.804C41.137 47 45 43.137 45 38.402V12.598C45 7.863 41.137 4 36.402 4Zm0 2h22.804A6.582 6.582 0 0 1 43 12.598v18.804A6.582 6.582 0 0 1 36.402 38H13.598A6.582 6.582 0 0 1 7 31.402V12.598A6.582 6.582 0 0 1 13.598 6ZM20 14v2h8c-5.922 6.277-5.91 12.586-6 14h2c.09-1.324.344-7.902 6-14v-2ZM7 36.902A8.585 8.585 0 0 0 13.598 40h22.804A8.585 8.585 0 0 0 43 36.902v1.5A6.582 6.582 0 0 1 36.402 45H13.598A6.582 6.582 0 0 1 7 38.402Z" />
    </svg>
);
export default SvgKey7;
